// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function order_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_id"), null));
  if (order_id.TAG === /* Ok */0) {
    var order_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_type"), null));
    if (order_type.TAG === /* Ok */0) {
      var order_date = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_date"), null));
      if (order_date.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  order_id: order_id._0,
                  order_type: order_type._0,
                  order_date: order_date._0
                }
              };
      }
      var e = order_date._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".order_date" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = order_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".order_type" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = order_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_id" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var orders = Decco.listFromJson(order_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "orders"), null));
  if (orders.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              orders: orders._0
            }
          };
  }
  var e = orders._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".orders" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  order_decode ,
  t_decode ,
  
}
/* No side effect */
